import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as moment from 'moment';

import { RemoteApiService, PlaylistResult } from '../core';
import { environment } from '../../environments/environment';

export interface ElasticSearchHit {
    id: string;
    segmentId: string;
    esId: number;
    mmStationId: number;
    stationName: string;
    market: string;
    segmentStartTime: string;
    segmentEndTime: string;
    offsetMillis: number;
    durationMillis: number;
    transcript: string;
    type: string;
}

export interface ElasticSearchResult {
    total: number;
    limit: number;
    transcripts: ElasticSearchHit[];
}


@Injectable()
export class TranscriptionSearchService {

    constructor(private remoteApi: RemoteApiService) { }

    findTranscriptions( keywords: string, stationIds: number[], markets: string[], startDate: Date, endDate: Date,
        sortKey: string, sortOrder = 'asc', pageNumber: number = 0, pageSize: number = 10): Observable<ElasticSearchResult> {

        const parameters: any = {
            keywords: keywords,
            offset: pageNumber * pageSize,
            limit: pageSize
        };

        if (stationIds != null && stationIds.length > 0) {
            parameters.stations = stationIds;
        }

        if (markets != null && markets.length > 0) {
            parameters.markets = markets;
        }

        if (startDate != null) {
            parameters.startDate = moment.utc(new Date(startDate)).toISOString();
        }

        if (endDate != null) {
            parameters.endDate = moment.utc(new Date(endDate)).toISOString();
        }

        if (sortKey) {
            parameters.sortKey = sortKey;
        }

        if (sortOrder) {
            parameters.sortOrder = sortOrder;
        }

        return this.remoteApi.getTranscript<ElasticSearchResult>(`/transcript`, parameters);
    }
}
